import { useTheme } from '@mui/material';
import EChartsReact from 'echarts-for-react';
import React from 'react';
import { generateColors, getValueFromPercent } from 'utils/helpers';
interface IQuestionLineChartProps {
    showLabel: boolean;
    data?: { name: string; value: number; value_percent: number }[];
    dataMulple?: {
        indicator: { name: number }[];
        legend: string[];
        data: {
            name: string;
            value: number[];
        }[];
    };
    isMultiple: boolean;
    total: number;
}
const QuestionLineChart: React.FC<IQuestionLineChartProps> = ({
    showLabel,
    data,
    isMultiple,
    dataMulple,
    total,
}) => {
    const theme = useTheme();
    const getSeries = () => {
        if (!isMultiple) {
            return [
                {
                    data: data?.map((item) => item.value_percent ?? 0),
                    type: 'line',
                    symbol: 'circle',
                    symbolSize: 10,
                    itemStyle: {
                        color: '#FF7916',
                        borderWidth: 2,
                    },
                    lineStyle: {
                        color: theme.palette.primary.main,
                        width: 2,
                    },
                    label: {
                        show: showLabel,
                        position: 'top',
                        formatter: (params: { value: number }) => {
                            return params.value + '%';
                        },
                    },
                },
            ];
        }
        const colors = generateColors(dataMulple?.data?.length ?? 0);
        return (dataMulple?.data ?? []).map((item, index) => ({
            name: item.name ?? `Series ${index + 1}`,
            type: 'line',
            symbol: 'circle',
            symbolSize: 10,
            data: (item.value ?? []).map((val) => val ?? 0),
            itemStyle: {
                color: colors?.[index] ?? '#000',
                borderWidth: 2,
                borderColor: '#fff',
            },
            lineStyle: {
                color: colors?.[index] ?? '#000',
                width: 2,
            },
            label: {
                show: showLabel,
                position: 'top',
                formatter: (params: { value: number }) => {
                    return params.value + '%';
                },
            },
        }));
    };
    return (
        <EChartsReact
            notMerge={true}
            style={{ height: 500 }}
            option={{
                color: isMultiple
                    ? generateColors(dataMulple?.data?.length ?? 0)
                    : [],
                legend: {
                    data: isMultiple ? dataMulple?.legend : [],
                    icon: 'circle',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                    },
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    formatter: function (params: any) {
                        if (isMultiple) {
                            let tooltip = `${params[0].axisValue}<br/>`;
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            params.forEach((item: any) => {
                                tooltip += `
          <span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color}"></span>
          ${item.seriesName}: <b>${getValueFromPercent(item.data, total, 0)}</b><br/>
        `;
                            });
                            return tooltip;
                        } else {
                            const item = Array.isArray(params)
                                ? params[0]
                                : params;
                            return `
        ${item.axisValue}<br/>
        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color}"></span>
        ${item.name}: <b>${getValueFromPercent(item.data, total, 0)}</b>
      `;
                        }
                    },
                },
                grid: {
                    left: '3%',
                    right: '3%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    data: isMultiple
                        ? dataMulple?.indicator?.map((item) => item.name)
                        : data?.map((item) => item.name),
                },
                yAxis: {
                    type: 'value',
                },

                series: getSeries(),
            }}
        />
    );
};

export default QuestionLineChart;
